// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"08a59616","790":"a72946f0","814":"e8fd6efd"}[chunkId] + ".chunk.js";
};